import QuestionsShow from './questions-show';
import Answers from '../data/answers';

export default class QuestionsFlow {
    constructor() {
        this.reset();
        this.answers = new Answers();
    }

    reset() {
        this.questions = [];
        this.question = null;
    }

    setQuestions(questions) {
        this.questions = questions;
    }

    setQuestion(question) {
        return (this.question = this.questions.find(q => q.id === question.id) || this.questions[0]);
    }

    setQuestionById(questionId) {
        const question = this.questions.find(question => question.id === questionId) || this.questions[0];

        if (question) {
            return (this.question = question);
        }
    }

    getQuestion() {
        if (!this.question) {
            return this.questions[0];
        }

        const question = this.questions.find(question => question.id === this.question.id) || this.questions[0];
        return (this.question = question);
    }

    getNextQuestion() {
        const index = this.questions.findIndex(question => question.id === this.question.id);
        let nextQuestion;

        for (let i = index + 1; i < this.questions.length; i++) {
            nextQuestion = this.questions[i];

            let showQuestion = new QuestionsShow(nextQuestion.show || []);
            if (showQuestion.can()) {
                break;
            } else {
                nextQuestion = null;
            }
        }

        return nextQuestion ? this.setQuestion(nextQuestion) : null;
    }

    setAnswer(answer) {
        this.answers.set(this.question.id, answer);
    }

    getAnswer(question) {
        return this.answers.get(question.id) || [];
    }
}